<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Panel Kullanıcı Ekle</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Ad</h4>
          <v-text-field
            v-model="userData.firstName"
            maxlength="255"
            counter="255"
            :rules="firstNameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Soyad</h4>
          <v-text-field
            v-model="userData.lastName"
            maxlength="255"
            counter="255"
            :rules="lastNameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Mail Adresi</h4>
          <v-text-field
            v-model="userData.email"
            maxlength="255"
            counter="255"
            :rules="emailRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <!-- <v-col cols="12" md="4">
          <h4>Şifre oluştur</h4>
          <v-text-field v-model="userData.password" disabled  :rules="passwordRules" required></v-text-field>
          <v-btn   depressed
            color="primary" @click="createPassword()">Şifre oluştur</v-btn>
        </v-col>
        <v-col cols="12" md="8"></v-col>-->
        <v-col cols="12" md="4">
          <h4>Rol</h4>
          <v-select
            v-model="userData.role"
            :items="allRoles"
            item-text="name"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <!-- <h4>Firma</h4>
          <v-text-field v-model="userData.company" :rules="companyRules" required></v-text-field>-->
          <h4>Firma</h4>
          <!-- <v-text-field v-model="userData.company" :rules="companyRules" required></v-text-field> -->
          <v-select
            v-model="userData.companyId"
            :items="allCompanyList"
            @change="companyChange"
            item-text="companyName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Mağaza/Tabela</h4>
          <v-select
            v-model="userData.venueId"
            :items="allVenues"
            item-text="venueName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="userData.active" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: right; color: white;"
            @click="panelUserAdd()"
          >
            EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PanelUser',
  data: () => ({
    userData: {
      firstName: '',
      lastName: '',
      email: '',
      active: true,
      companyId: 0,
      venueId: 0,
      role: null,
    },
    errorList: [],
    dialog: false,
    valid: true,
    firstNameRules: [
      (v) => !!v || 'Ad alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    lastNameRules: [
      (v) => !!v || 'Soyad alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    emailRules: [
      (v) => !!v || 'Email alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Lütfen geçerli bir mail adresi giriniz.',
    ],
    // passwordRules: [
    //   v => !!v || "Şifre alanı zorunludur.",
    //   v => v.length > 5 || "Şifre 6 karakter olmalıdır"
    // ],
    companyRules: [(v) => !!v || 'Firma alanı zorunludur.'],
    allRoles: [
      {
        id: 'PanelUser',
        name: 'Admin',
      },
      {
        id: 'PanelVenueUser',
        name: 'Üye İş Yerleri',
      },
      {
        id: 'PanelReportUser',
        name: 'Rapor Erişimi',
      },
    ],
  }),
  computed: mapGetters(['allVenues', 'allCompanyList']),
  created() {
    this.getCompanieList().then((response) => {
      this.userData.companyId = response[0].id
      this.getVenues(response[0].id).then((data) => {
        this.userData.venueId = data[0].id
        //this.addAllVenuesOption();
      })
    })
    this.userData.role = this.allRoles[0].id
  },
  methods: {
    ...mapActions([
      'getVenues',
      'postAddPanelUser',
      'getCreateRandomPasssword',
      'getCompanieList',
    ]),
    // createPassword() {
    //   this.getCreateRandomPasssword().then(response=>{
    //     this.userData.password = response;
    //   })
    // },
    companyChange(companyId) {
      console.log('com', companyId)
      this.getVenues(companyId).then((data) => {
        this.userData.venueId = data[0].id
        this.addAllVenuesOption()
      })
    },
    addAllVenuesOption() {
      this.allVenues.unshift({ id: 0, venueName: 'Hepsi' })
    },
    routePanelUsers() {
      this.$router.push('/dashboard/users/panelUsers')
    },
    panelUserAdd() {
      if (this.$refs.form.validate()) {
        this.snackbar = true

        this.postAddPanelUser(this.userData)
          .then((response) => {
            if (response.processStatus == 'Success') {
              this.routePanelUsers()
            }
          })
          .catch((err) => {
            if (err.response.data) {
              const errorKey = err.response.data.friendlyMessage.message
              if (errorKey == 'panel_user_already_exist') {
                alert(
                  'Girmiş olduğunuz e-posta adresi ile bir kullanıcı mevcut.',
                )
              } else {
                alert('Bir hata oluştu')
              }
            } else {
              alert('Bir hata oluştu')
            }
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

        this.dialog = true
      }
    },
  },
  watch: {
    'userData.role': function (nw) {
      if (nw == this.allRoles[0].id) {
        if (this.allVenues[0].id == 0) this.allVenues.splice(0, 1)
        if (this.userData.venueId == 0) this.panelUser.venueId = null
      } else this.addAllVenuesOption()
    },
  },
}
</script>
